import React, { useEffect, useState, useLayoutEffect } from "react";
import { Link } from 'react-router-dom';
import { Box } from "@material-ui/core";
import { viewFileAction } from "../redux/actions/CustomerAction";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from "@material-ui/core/Grid";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import ExcelImage from "../ExcelLarge.png";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { gridFocusColumnHeaderSelector } from "@material-ui/data-grid";
export default function CustomImage({ option, index, deletedFiles, setDeletedFiles, editFlag, filesInfo ,setState,fields}) {
    const [customUrl,setCustomUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [fileStatus, setFileStatus] = useState(true);
    const [file,setFile] = useState({});
    const [docs, setDocs] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const deleteFileHandling = (event,id) => {
        setDeletedFiles(
            [...deletedFiles, parseInt(id)]);

        setFileStatus(false);
        setState({
            ...fields,
            changeStatus:true
        })
    };
    const fileItem= filesInfo.filter((value, index) => {
        return value.id === option;

    }, option)[0]
    useEffect(() => {
        
        setLoading(true)
       
        viewFileAction(fileItem).then(res => {
            setCustomUrl(res)
            setLoading(false); 
        })
        return () => {
            setCustomUrl('') ;
            setIsOpen(false)// This worked for me
        };

    }, [])
    

    return (
        <>{fileStatus && <Grid
            item
            xs={10} sm={3}>  {loading && 
        <div style={{ position: "relative", height: "233px", width: "100%", paddingTop: "115x", paddinLeft: "175px" }}>
            <span style={{ transform: "translateY(-50%) translateX(-50%)", position: "absolute",  top: "50%", left: "50%" }}>Loading {++index}.....</span></div>}
            {!loading &&
                  <Box
                sx={{
                        height: 240,
                      width: '100%',

                        objectFit: "cover",
                        my:3,
                        maxHeight: { xs: '233', md: '167' },
                    maxWidth: { xs: '100%', md:'90%' },
                    position:"relative",
                    display:'flex',
                    flexWrap:'wrap'
                }}
              
                >
                    { 
                    editFlag?
                        <DeleteIcon
                            color="secondary"
                                style={{
                                    color: "#ff0000", position: "absolute", cursor: 'pointer', right: "0px", top: "0px", zIndex: 5 ,background: "#000",
                                    padding: "5px"}}
                            id={option}
                            onClick={(event) => {
                                deleteFileHandling(event,option);
                            }}
                            
                        />
                    :
                        ""
                    }
                    {
                        (fileItem.file_extension === 'pdf' || fileItem.file_extension === 'xlsx') && 
                    <>
                        
                        {
                                fileItem.file_extension === 'pdf' &&
                            <a href={customUrl} target="_blank"
                                        style={{ position: "relative", height: "240", width: "100%", display: "flex", flexWrap: "wrap" }}>
                                <div style={{ width: "400px", overflow: "hidden", height: "220px" }}>
                                
                                        <PictureAsPdfIcon
                                            color="secondary"
                                            style={{ color: "gray", width: "170px", height: "220px",  position: "absolute", cursor: 'pointer' }}
                                            id={option}
                                            // onClick={(event) => {
                                            //     window.open({ customUrl })
                                            // }}

                                        />
                                </div>
                                
                            </a>  
                         }   
                        { 
                                fileItem.file_extension === 'xlsx' &&
                            <a target="_blank" href={customUrl} > 
                                <img src={ExcelImage} style={{ width: "248px", overflow: "hidden", height: "220px" }}></img>
                            </a>
                        
                        }

                            <span style={{ color: "#0d0d0d", fontWeight: "bold", fontSize: "14px", maxWidth: "185px", whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{fileItem.file_name}.{fileItem.file_extension}</span>
                    </>
                    }
                    {['jpeg', 'jpg', 'png', 'JPG', 'JPEG','PNG'].includes(fileItem.file_extension) && 
                        <><ZoomOutMapIcon
                            color="secondary"
                        style={{
                            color: "#fff", position: "absolute", cursor: 'pointer', right: "0px", top: "25px", zIndex: 5, background: "#000",
                            padding: "5px" }}
                            id={option}
                            onClick={(event) => {
                                setIsOpen(true)
                            }}

                        /><Box
                component="img"
                sx={{
                    height: 220,
                    width: '100%',
                    objectFit:"cover",
                    pointerEvents: editFlag?"auto":"none",
                    maxHeight: { xs: '233', md: '167' },
                    maxWidth: { xs: '100%', md: '100%' },
                    display: 'flex',
                    flexWrap: 'wrap',
                    paddingTop:15,
                    paddingBottom: 15,
                    cursor:'pointer!important'
                }}

                        src={customUrl}
                      
              
                    />
                      
                    
                        <span style={{ color: "#0d0d0d", fontWeight: "bold", fontSize: "14px" ,maxWidth: "185px", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{fileItem.file_name}.{fileItem.file_extension}</span>
                    </>}
                    {isOpen && (
                        <Lightbox
                            mainSrc={customUrl}
                            onCloseRequest={() => setIsOpen(false)}
                           
                         
                        />
                    )}
            </Box>
             
                 
            }       </Grid>
        }
        </>
    );
}
